<script>
    import { format } from "svelte-i18n";
    export let note;

    const md = new window.markdownit({html:false});
</script>

<style></style>

<div>{@html  md.render(note.content) || $format("page.vulnerability.empty_note")}</div>
